import i18n from '@/i18n'

export interface PenaltyNotice {
  id: number
  vliveId: string
  penaltyType: PenaltyType
  penaltyReason: PenaltyReason
  penaltyPlace: PenaltyPlace
  category: PenaltyCategory
  openTime: string
  closeTime: string
}

export const penaltyTypes = {
  Warning: 1, // 警告
  Suspend: 2, // 一時停止
  Stop: 3, // 停止
} as const
export type PenaltyType = typeof penaltyTypes[keyof typeof penaltyTypes]

export const penaltyReasons = {
  AntiSocial: 1, // 1.反社会的行為
  Obscenity: 2, // 2.わいせつ・暴力的表現・出会い目的行為
  Commercial: 3, // 3.商業行為
  PersonalInfo: 4, // 4.個人情報掲載行為
  Official: 5, // 5.公式表示
  Misconduct: 6, // 6.不正行為
  Other: 7, // 7.その他
} as const
export type PenaltyReason = typeof penaltyReasons[keyof typeof penaltyReasons]

export const penaltyPlaces = {
  MediaComment: 1, // 配信コメント
  MediaContent: 2, // 配信内容
  MediaTitle: 3, // 配信タイトル
  Profile: 4, // プロフィール
  Other: 5, // 該当なし
  Chat: 6, // チャット
  VideoChat: 7, // ビデオチャット
  ObsStreaming: 8, // OBS映像
  FeedPost: 9, // フィード投稿
  FeedComment: 10, // フィードコメント
} as const
export type PenaltyPlace = typeof penaltyPlaces[keyof typeof penaltyPlaces]

export const penaltyCategories = {
  Illegal: 1, // 違法行為
  Suicide: 2, // 自殺
  Dating: 3, // 出会い
  PersonalInfo: 4, // 個人情報
  Calumny: 5, // 誹謗中傷・名誉毀損
  Violence: 6, // 暴力
  Spoofing: 7, // なりすまし
  Obscenity: 8, // 卑猥・猥雑
  Commercial: 9, // 商用利用
  Url: 10, // URL
  Rights: 11, // 著作権・肖像権
  Troll: 12, // 荒らし
  Misconduct: 13, // 不正行為
  Other: 14, // その他
  PointFraud: 15, // 評価ポイントに関する不正行為
} as const
export type PenaltyCategory =
  typeof penaltyCategories[keyof typeof penaltyCategories]
